export default __webpack_public_path__ + "4308b9723232ab263e629ff6d1400163.png";